export function cookieDomain(hostname) {
    const protocol = process.env.NODE_ENV === 'production' ? 'https:' : 'http:';

    const domainInfo = hostname
        ? new URL(`${protocol}//${hostname}`).hostname.split('.')
        : typeof window !== 'undefined'
            ? window.location.hostname.split('.')
            : null;

    if (!domainInfo) {
        console.warn(`WARNING! Could not detect cookieDomain for hostname ${hostname}`);

        return null;
    }

    return `.${domainInfo[domainInfo.length - 2]}.${domainInfo[domainInfo.length - 1]}`;
}

export function protocol(url) {
    if (url.startsWith('http') || url.startsWith('https')) return url;

    const [baseURL] = url.replace(/^https?:\/\//, '').split('/')[0].split(':');

    return `${baseURL.endsWith('.local') ? 'http' : 'https'}://${url}`;
}
